module.exports = __webpack_public_path__ + "static/media/graphic-dashboard-move-money@2x.016fbf98.png";